var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAkarIconsLinkedinBoxFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_5)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.625 1.77375C0.625331 1.46919 0.746466 1.17719 0.961827 0.961828C1.17719 0.746467 1.46918 0.625332 1.77375 0.625002H13.225C13.376 0.624755 13.5255 0.654291 13.6651 0.711918C13.8046 0.769546 13.9315 0.854133 14.0383 0.960837C14.1451 1.06754 14.2298 1.19427 14.2876 1.33376C14.3454 1.47325 14.3751 1.62277 14.375 1.77375V13.225C14.375 13.5299 14.2539 13.8223 14.0384 14.038C13.8229 14.2536 13.5305 14.3748 13.2256 14.375H1.77375C1.46908 14.3747 1.17698 14.2534 0.961606 14.038C0.746227 13.8225 0.625165 13.5303 0.625 13.2256V1.77375ZM6.0675 5.8675H7.92938V6.8025C8.19813 6.265 8.88562 5.78125 9.91875 5.78125C11.8994 5.78125 12.3688 6.85188 12.3688 8.81625V12.455H10.3644V9.26375C10.3644 8.145 10.0956 7.51375 9.41312 7.51375C8.46625 7.51375 8.0725 8.19438 8.0725 9.26375V12.455H6.0675V5.8675ZM2.63 12.3694H4.635V5.78125H2.63V12.3694ZM4.92188 3.6325C4.92566 3.80417 4.89511 3.97487 4.83202 4.13457C4.76894 4.29428 4.67459 4.43977 4.55452 4.56252C4.43444 4.68527 4.29106 4.7828 4.13278 4.84938C3.97451 4.91596 3.80452 4.95026 3.63281 4.95026C3.4611 4.95026 3.29112 4.91596 3.13284 4.84938C2.97456 4.7828 2.83118 4.68527 2.71111 4.56252C2.59103 4.43977 2.49668 4.29428 2.4336 4.13457C2.37052 3.97487 2.33997 3.80417 2.34375 3.6325C2.35117 3.29554 2.49024 2.97487 2.73118 2.73918C2.97212 2.50349 3.29576 2.37151 3.63281 2.37151C3.96986 2.37151 4.29351 2.50349 4.53445 2.73918C4.77538 2.97487 4.91445 3.29554 4.92188 3.6325Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsLinkedinBoxFill);
export default __webpack_public_path__ + "static/media/akar-icons_linkedin-box-fill.8f7c242fbc71c1fd6391bcf607e32d1b.svg";
export { ForwardRef as ReactComponent };